<template>
  <div>
          <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    <v-container fluid v-if="tclist">
      <v-row>
        <v-col class="d-flex" cols="12" sm="6">
          <v-select
            :items="tclist"
            label="Tenant"
            v-model="selected_tenant"
            @change="fetchorganization()"
          ></v-select>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid id="orgdiv" v-if="orglist">
      <v-row>
        <v-col class="d-flex" cols="10" sm="6">
          <v-select
            :items="orglist"
            label="Organization"
            v-model="selected_org"
            @change="fetchcurrroles()"
          ></v-select>
        </v-col>
      </v-row>
    </v-container>
    <template v-if="role_list">
      <v-card>
 <v-data-table 
      :headers="headers"
      :items="role_list"
      :search="search"
></v-data-table>
      </v-card>
    </template>
  </div>
</template>


<script>
import axios from "axios";
export default {
  data: () => ({
    tclist: null,
    selected_tenant: "",
    orglist:null,
    selected_org: "",
       snackbar_msg: "",
    snackbar: false,
    color: "",
    role_list:null,
    search:'',
    headers:[
         { text: "Module", value: "module", sortable: true },
         { text: "Module Active", value: "module_active", sortable: true },
         { text: "User Type", value: "user", sortable: true },
         { text: "Role", value: "role", sortable: true },
         { text: "Role Active", value: "role_active", sortable: true },
    ]
  }),

  mounted() {
    axios
      .post("/Admin/startCopy")
      .then(res => {
        window.console.log(res);
        if (res.data.msg == "200") {
          this.tclist = res.data.tenants;
        } else {
          this.message = res.data.msg;
        }
      })
      .catch(error => {
        window.console.log("error:" + error);
      });
  },

  methods: {
        showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    fetchorganization() {
      const data = {
        tenantid: this.selected_tenant
      };
      axios
        .post("/Admin/fetchOrganization", data)
        .then(res => {
          window.console.log(res);
          if (res.data.msg == "200") {
            this.orglist = res.data.org;
            //this.orglist.name=res.data.org.name
            //document.getElementById("orgdiv").style.display = "block";
            //this.domainpath=res.data.domainpath
          } else {
            this.message = res.data.msg;
          }
        })
        .catch(error => {
          window.console.log("error:" + error);
        });
    },
    fetchcurrroles() {
        const formData={
            tenantid:this.selected_tenant ,   
            orgid:this.selected_org    
        }
        axios
        .post("/admin/get_all_roles",formData)
        .then(res => {
           this.role_list = res.data.role_list
           this.showSnackbar("#4CAF50","Roles added succesfully")

        })
        .catch(error => {
          this.showSnackbar("#b71c1c","Something went wrong!!!")
        })
        .finally(() => {
            //stop loader 
        });
    },
  }
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>